/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusStammdatenTyp } from '../../models/lexplus-stammdaten-typ';
import { LexplusSuccessDto } from '../../models/lexplus-success-dto';

export interface StammdatenControllerRemoveV1$Params {
  id: number;

/**
 * Delete every descendant of the entry along with it.
 */
  deleteChildren?: boolean;

/**
 * Move the direct children of the entry below `newParentId` instead of blocking the delete.
 */
  moveChildren?: boolean;

/**
 * The parent the children move to with `moveChildren`; omitted, they move to root level.
 */
  newParentId?: number;
  typ: LexplusStammdatenTyp;
}

export function stammdatenControllerRemoveV1(http: HttpClient, rootUrl: string, params: StammdatenControllerRemoveV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusSuccessDto>> {
  const rb = new RequestBuilder(rootUrl, stammdatenControllerRemoveV1.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('deleteChildren', params.deleteChildren, {});
    rb.query('moveChildren', params.moveChildren, {});
    rb.query('newParentId', params.newParentId, {});
    rb.path('typ', params.typ, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusSuccessDto>;
    })
  );
}

stammdatenControllerRemoveV1.PATH = '/v1/stammdaten/{typ}/{id}';
